document.addEventListener('turbo:load', function () {
  if (window.AskHugo) {
    AskHugo.start()
  }
})
